import React from 'react'
import {AiFillLinkedin} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'
import {AiFillFacebook} from 'react-icons/ai'
import {AiFillTwitterSquare} from 'react-icons/ai'
import {BsInstagram} from 'react-icons/bs'

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
      <a href='https://www.linkedin.com/in/niko-boykin-a46a3a241/' target="_blank"><AiFillLinkedin/></a>
      <a href='https://github.com/Nikoboykin' target="_blank"><AiFillGithub/></a>
      <a href='https://www.facebook.com/' target="_blank"><AiFillFacebook/></a>
      <a href='https://twitter.com/?lang=en' target="_blank"><AiFillTwitterSquare/></a>
      <a href='https://www.instagram.com/' target="_blank"><BsInstagram/></a>
    </div>
  )
}

export default HeaderSocials